// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__8GU9o","label":"LabeledBox_label__1xin7"};